import { v4 as uuid } from "uuid";

import { IClassroomResource } from "../../classrooms";
import { IProfessionalSituationResource } from "../../professional-situations";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IEducationalScenarioItem } from "../types/IEducationalScenarioItem";

interface EducationalScenarioItemCreateMutationData {
    professionalSituation: RelationalValue<IProfessionalSituationResource>;
    classroom: RelationalValue<IClassroomResource>;
    startDate: string;
    endDate: string;
    uuid?: string;
}

export type IEducationalScenarioItemCreateMutationParameters = {
    data: EducationalScenarioItemCreateMutationData;
};

export type IEducationalScenarioItemCreateMutationResult = IEducationalScenarioItem;

export const educationalScenarioItemCreateMutation: IApiMutationFunction<
    IEducationalScenarioItemCreateMutationParameters
> = ({ data: { professionalSituation, classroom, ...data } }) => {
    return {
        method: "POST",
        url: `/educational_scenario_items`,
        data: {
            uuid: uuid(),
            ...data,
            professionalSituation: `/professional_situations/${mapRelationalValue(professionalSituation)}`,
            classroom: `/classrooms/${mapRelationalValue(classroom)}`,
        },
    };
};

export const useEducationalScenarioItemCreateMutation = createApiMutationHook<
    IEducationalScenarioItemCreateMutationParameters,
    IEducationalScenarioItemCreateMutationResult
>(educationalScenarioItemCreateMutation);
